import React from 'react';

export const TransactionsContext = React.createContext();
export const MoneyContext = React.createContext();